<template>
	<div style="position: relative;width: 100%;height: 100%;">
		<div id="livePlayer" style="height: 230px;"></div>
		<div id="liveChat" style="position:absolute;top:230px;width:100%;"></div>
		<div ref="cindex" style="display: none;">
			<ctree  v-for="(item,index) in courseResourceTreeData.children" :key="index" :treelist="item" @treeTap="coursetreeplay" :treelistindex="0"></ctree>
		</div>
	</div>
</template>

<script>
import ctree from '@/components/ctree.vue';
import { Toast } from 'vant';
import {api_user,api_goods} from '@/common/Request.js';
export default {
	data () {
	  return {
	    goodsid:'',
		goodsinfo:'',
		usertoken:'',
		userinfo:'',
		liveplayercomp:null,
		roomid:'',
		chatroom:null,
		courseId:'',
		resourceId:'',
		courseResourceTreeData:'',
	  }
	},
	mounted(){
		if(this.$cookies.isKey("user_token"))
		{
			this.usertoken=this.$cookies.get("user_token");
			this.courseId=this.$route.query.courseId;
			this.resourceId=this.$route.query.resourceId;
			api_goods.goods_detail(this.courseId).then(response => {
				this.goodsinfo=response.data;
				document.title=this.goodsinfo.name;
				this.courseResourceTreeListLoad();
			});
			
			api_user.getPlayData(this.courseId,this.resourceId).then(res=>{
				console.log(res);
				if(res.data.hasOwnProperty("channelId")){
					if(res.data.channelId!=0){
					this.live_init(res.data.channelId,res.data.uid);
					}
					else{
						Toast.fail("直播数据错误，请联系管理员处理！");
					}
				}
				else{
					Toast.fail("直播数据错误，请联系管理员处理！");
				}
			});
		}
	},
	methods:{
		live_init(roomid,uid)
		{
			console.log(roomid);
			this.liveplayercomp = polyvObject('#livePlayer').livePlayer({
					    'width':'100%',
					    'height':'100%',
					    'uid':uid,
					    'vid':roomid,
						'param1':this.$cookies.get('userId'),
						//'param2':this.$cookies.get('nickName')
				});
				
				api_user.getUserInfoAtClass().then(res=>{
					var myrealname=""
					if(res.code==0){
						myrealname=res.data.realName;
					}
				this.chatroom = new PolyvChatRoom({
			    roomId: roomid,
			    userId: this.$cookies.get('userId'),
			    nick: myrealname,
			    pic: 'http://livestatic.videocc.net/assets/wimages/missing_face.png',
			    token: '123456',
			    container: '#liveChat',
				width: '100%',
				height: document.documentElement.clientHeight-230,
			    userType: '',
				tabData:[{name:'聊天',type:'chat'},{name:'提问',type:'ask'},{name:'课程表',type:'courseindex'}],
			    roomMessage: function(data) {
			        // TODO
			        // data为聊天室socket消息，当有聊天室消息时会触发此方法
			        console.log(data);
			    }
			});
			
			console.log(this.chatroom);
			
			});
			console.log(this.$refs.cindex);
			
			
			var coursetab=document.querySelector('#tab-courseindex');
			coursetab.appendChild(this.$refs.cindex);
			this.$refs.cindex.style.display='block';
			//console.log(document.querySelector('#tab-courseindex'));
		},phonemask(phonenumber)
			{
				var mystr=new String(phonenumber);
				var res=mystr.substr(0,3)+'****'+mystr.substr(7,mystr.split('').length);
				return res;
			},
		courseResourceTreeListLoad(){
				api_user.getCourseResourceTree(this.courseId).then(res=>{
					console.log(res);
					const treedata=res.data.root;
					this.courseResourceTreeData=treedata;
					//this.treefilter(this.courseResourceTreeData);
					console.log(this.courseResourceTreeData);
				})
			},
			treefilter(treeNodes){
				    if(!treeNodes||!treeNodes.length)return;
				    for(let i=0;i<treeNodes.length;i++){
				        let childs=treeNodes[i].children;
						if(treeNodes[i].isLeaf){
							let iconhtml="";
							if(treeNodes[i].item.resourceType==1){
								iconhtml="<i class='anticon anticon-desktop'></i> ";
								if(treeNodes[i].item.lessonStatus==3){
									treeNodes[i].item.alias=treeNodes[i].item.alias+" ("+this.formattime("YYYY-mm-dd HH:MM",new Date(treeNodes[i].item.lessonStartTime))+" 课程回放)";
								}
								else if(treeNodes[i].item.lessonStatus==0){
									treeNodes[i].item.alias=treeNodes[i].item.alias+" ("+this.formattime("YYYY-mm-dd HH:MM",new Date(treeNodes[i].item.lessonStartTime))+" 开始直播)";
								}
								else if(treeNodes[i].item.lessonStatus==1){
									treeNodes[i].item.alias=treeNodes[i].item.alias+" (直播中)";
								}
								else if(treeNodes[i].item.lessonStatus==2){
									treeNodes[i].item.alias=treeNodes[i].item.alias+" (直播完成待转码)";
								}
							}
							else if(treeNodes[i].item.resourceType==2){
								iconhtml="<i class='anticon anticon-play-circle-o'></i> ";
							}
							else if(treeNodes[i].item.resourceType==9){
								iconhtml="<i class='anticon anticon-user'></i> ";
							}
							treeNodes[i].title=iconhtml+treeNodes[i].item.alias;
							//treeNodes[i].title=treeNodes[i].item.alias;
						}
						else{
							treeNodes[i].title=treeNodes[i].item;
							treeNodes[i].expanded=true;
						}
				        console.log(treeNodes[i])
				        if(childs&&childs.length>0){
				            this.treefilter(childs);
				        }
				    }
			},
			coursetreeplay(data){
				console.log(data);
				console.log(this.goodsinfo);
				if(data.isLeaf){
					if(this.goodsinfo.hasBuy){
						if(data.item.resourceType==1){
							
							if(data.item.lessonStatus<3){
								this.$router.push({
								  path: "live_detail",
								  query: { courseId: this.courseId,
										   resourceId: data.item.resourceId
								   }
								});
							}
							else{
								this.$router.push({
								  path: "live_replay",
								  query: { courseId: this.courseId,
										   resourceId: data.item.resourceId
								   }
								});
							}
			
							//location.reload();
						}
						else if(data.item.resourceType==2){
							console.log("playvideo")
							this.$router.push({
							  path: "course_detail",
							  query: { courseId: this.courseId,
									   resourceId: data.item.resourceId
							   }
							});
							//location.reload();
						}
						else if(data.item.resourceType==9){
							Toast.fail('该课程为线下课程，请联系教务老师确定上课时间地点！');
						}
					}
					else if(data.item.trySee==1){
						if(data.item.resourceType==1){
							
							if(data.item.lessonStatus<3){
								this.$router.push({
								  path: "live_detail",
								  query: { courseId: this.courseId,
										   resourceId: data.item.resourceId
								   }
								});
							}
							else{
								this.$router.push({
								  path: "live_replay",
								  query: { courseId: this.courseId,
										   resourceId: data.item.resourceId
								   }
								});
							}
									
							//location.reload();
						}
						else if(data.item.resourceType==2){
							console.log("playvideo")
							this.$router.push({
							  path: "course_detail",
							  query: { courseId: this.courseId,
									   resourceId: data.item.resourceId
							   }
							});
							//location.reload();
						}
					}
					else{
						Toast.fail('请先购买课程！');
					}
				}
				
			},
			formattime(fmt, date){
					        let ret;
					        const opt = {
					            "Y+": date.getFullYear().toString(),        // 年
					            "m+": (date.getMonth() + 1).toString(),     // 月
					            "d+": date.getDate().toString(),            // 日
					            "H+": date.getHours().toString(),           // 时
					            "M+": date.getMinutes().toString(),         // 分
					            "S+": date.getSeconds().toString()          // 秒
					            // 有其他格式化字符需求可以继续添加，必须转化成字符串
					        };
					        for (let k in opt) {
					            ret = new RegExp("(" + k + ")").exec(fmt);
					            if (ret) {
					                fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
					            };
					        };
					        return fmt;
			
			},
		},
		components: {
		ctree
		}
	}
</script>

<style scoped>
  .replaylink{
    font-size: 0.8rem;
    color:cadetblue;
    text-shadow: #CCCCCC;
    font-weight: 900;
  }
  ::v-deep .tab-courseindex{
	  background: white;
  }
  
  ::v-deep .mycell{
	  padding: 10px 16px !important;
  }
</style>
